import $ from '@rover/globals/jquery';
import parseApiErrors from '@rover/utilities/parseApiErrors';

const CUSTOMER_SUPPORT_PHONE = '888-453-7889';

export default class {
  static showToast({
    severity = 'info',
    message = '',
    container = '.js-alerts-container',
    showCloseButton = true,
  } = {}) {
    const parentContainer = $(container);
    const severityClass =
      ['success', 'info', 'warning', 'danger'].indexOf(severity) !== -1 ? severity : 'info';
    const closeButton = showCloseButton
      ? '<button type="button" class="close js-alert-close" data-dismiss="alert" aria-hidden="true">&times;</button>'
      : '';
    const rendered = `
            <div class="alert alert-${severityClass} padded fade in js-alert">
                ${closeButton}
                ${message}
            </div>
        `;
    parentContainer.append(rendered);
  }

  static showAlert({ attemptedAction = 'processing your request' } = {}) {
    // eslint-disable-next-line no-alert
    alert(
      `Oops, we encountered an error while ${attemptedAction}. Please try again shortly or contact Customer Support at ${CUSTOMER_SUPPORT_PHONE}.`
    );
  }

  static alertApiError(err) {
    let formattedError;

    if (typeof err === 'object') {
      formattedError = JSON.stringify(err);
    } else {
      formattedError = err;
    }

    if ($('.js-alerts-container').length) {
      this.showToast({ message: formattedError, severity: 'danger' });
      scrollTo($('.js-alerts-container'), 0);
    } else {
      this.showAlert({
        attemptedAction: `processing your request: ${formattedError}`,
      });
    }
  }

  static failedApiResponse(response) {
    const errors = parseApiErrors(response);
    if (errors === undefined || errors.length == 0) {
      this.alertApiError(
        `Oops, we encountered an error while processing your request. Please try again shortly` +
          ` or contact Customer Support at ${CUSTOMER_SUPPORT_PHONE}.`
      );
      return;
    }
    errors.forEach(err => this.alertApiError(err));
  }
}



// WEBPACK FOOTER //
// ../utilities/Alerts.js